export default __webpack_public_path__ + "static/media/team-comparison.c5ea534f.svg";